module.exports = ".language-form {\n  width: 300px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/language/addedit-language/addedit-language.component.scss
// module id = ./src/app/component/language/addedit-language/addedit-language.component.scss
// module chunks = main